import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/rates';

// Full resolved rate card. The PricingTable renders errors inline
// (its own Alert), so there is no global Error dispatch, and the
// failure payload keeps the exact message extraction the table used
// before the saga migration.
function* process() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/rates`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data?.data ?? response.data ?? {}));
  } catch (error) {
    yield put(fetchFailure(
      error?.response?.data?.status
      || error?.message
      || 'Could not load pricing',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
